<template>
  <div class="register-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page register-page section-image" filter-color="black">
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                <card type="signup">
                  <template slot="header">
                    <h4 class="card-title text-center">Register</h4>
                  </template>
                  <ValidationObserver ref="registerForm" v-slot="{ handleSubmit }">
                    <form>
                      <ValidationProvider name="name" rules="required|min:2" v-slot="{ errors }">
                        <fg-input
                          v-model="form.name"
                          :error="errors[0]"
                          addon-left-icon="nc-icon nc-single-02"
                          placeholder="Firstname"
                        ></fg-input>
                      </ValidationProvider>
                      <ValidationProvider name="surname" rules="required|min:2" v-slot="{ errors }">
                        <fg-input
                          v-model="form.surname"
                          :error="errors[0]"
                          addon-left-icon="nc-icon nc-single-02"
                          placeholder="Lastname"
                        ></fg-input>
                      </ValidationProvider>
                      <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                        <fg-input
                          v-model="form.email"
                          :error="errors[0]"
                          addon-left-icon="nc-icon nc-email-85"
                          placeholder="Email address"
                        ></fg-input>
                      </ValidationProvider>
                      <div class="text-center">
                        Go back to
                        <router-link :to="{name: 'Login'}">Login</router-link>
                      </div>
                      <p-button slot="footer" type="warning" round block @click="handleSubmit(register)">Register</p-button>
                    </form>
                  </ValidationObserver>
                </card>
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/jan-sendereks.jpg)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import {Card, Checkbox, Button, InfoSection} from "src/components/UIComponents";

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    InfoSection,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      form: {
        name: "",
        surname: "",
        email: "",
        ngo_ID:0,
        location_ID:0,
        language_ID:0
      }
    };
  },
  methods: {
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    register(){
      this.$store.dispatch("user/register", this.form)
      .then(response => {
         this.showAlertMessage(response.data.message, "success");
         this.$router.push({ name: "Login" });
      }).catch(error => {
         this.showAlertMessage(error.response.data.message, "error");
      });
    }
  },
  beforeDestroy() {
     this.closeMenu();
  },
};
</script>
<style>
</style>
